export enum PermissionLevel {
  FULL_ALL_BUSINESS_UNITS = 1,
  FULL_BUSINESS_UNIT_ONLY,
  FULL_CREATED_BY_ME,
  READ_ONLY_ALL_BUSINESS_UNITS,
  READ_ONLY_BUSINESS_UNIT,
  NO_ACCESS,
}
